export const enginesItems = [
    "110109858R",
    "110101542R",
    "110101492R",
    "8201627658",
    "7701476562",
    "8201456632",
    "7701477101",
    "8200728389",
    "110109069R",
    "E3BG6011DA",
    "6001549089",
    "377819021D",
    "5Q0959811D",
    "5W0959781",
    "5Z9955711C",
    "8201678681",
    "8201678680",
    "04C100031F",
    "04C100034C",
    "8201348578",
    "100010018R",
    "100018560R",
    "8201315858",
    "8201681335",
    "8201450435",
    "7091967",
    "7092258",
    "73504151",
    "73504263",
    "04C100034",
    "04E100033M",
    "04E100035K",
    "1140037330",
    "190000Y170",
    "36003436",
    "36010313",
    "544018344R",
    "55258767",
    "55277138",
    "56330R1000",
    "7087096",
    "8201654865",
    "8201738489",
    "853300D100",
    "853300D190",
    "8533047090",
    "8533047091",
    "1000C761",
    "FB3Q6006GA",
    "110102713R",
    "7091969",
    "11008560352",
    "36010304",
    "55270179",
    "7092810",
    "D3BG6011AA",
    "04E100039M",
    "04E100012AM",
    "04C100034D",
    "55224801",
    "55261470",
    "55278881",
    "E3BZ6006C",
    "FB3Z6006H",
    "GN1Z6006K",
    "55272080",
    "46346812",
    "97651085",
    "55258758",
    "7087095",
    "46345650",
    "11000EM50G",
    "7092256",
    "7095321",
    "94718747",
    "24579316",
    "98500108",
    "24585533",
    "98500220",
    "24585532",
    "7S7Z6010F",
    "55271877",
    "97651022",
    "638157580",
    "1140180838",
    "7091966",
    "55271867",
    "7087413",
    "7087221",
    "46350563",
    "55222548",
    "101025X00A",
    "7095920",
    "25205371",
    "030100038C",
    "195N12BU01",
    "032100033H",
    "97650993",
    "97651079",
    "7092834",
    "55245115",
    "7095924",
    "1638158880",
    "1010201Q4F",
    "101033BR0A",
    "101033HU0A",
    "D3BG6006EA",
    "7095919",
    "46346809",
    "DM5G6006DA",
    "04E100035T",
    "5802422282",
    "7095323",
    "101035RA2A",
    "7095917",
    "7095916",
    "7096994",
    "7094880",
    "7096624",
    "7095926",
    "46346810",
    "7096626",
    "7096973",
    "CP9Z6009A",
    "D3BG6006AA",
    "J2GZ6006E",
]